import { Link } from 'react-router-dom';
import { categories } from '@/mocks/news';

export default function SiteFooter() {
  return (
    <footer className="bg-secondary-900 text-secondary-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12 md:gap-8">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-background-50">
                <i className="ri-flashlight-fill text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-xl font-bold text-background-50">看料大瓜</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-secondary-200">
              按时间线汇总近期最热门的娱乐话题与精华讨论，帮你用最短的时间补齐事件脉络。只做话题梳理与现象观察，把判断权交回给你。
            </p>
            <p className="mt-5 text-sm text-secondary-200">
              联系邮箱：
              <a
                href="mailto:hello@kanliaodagua.example"
                rel="nofollow"
                className="text-primary-300 underline-offset-4 hover:underline"
              >
                hello@kanliaodagua.example
              </a>
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-heading text-base font-semibold text-background-50">
              <Link to="/topics" className="hover:text-primary-300">
                内容分类
              </Link>
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link to="/topics" className="text-secondary-200 transition-colors hover:text-primary-300">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-heading text-base font-semibold text-background-50">
              <Link to="/about" className="hover:text-primary-300">
                关于本站
              </Link>
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <Link to="/about" className="text-secondary-200 transition-colors hover:text-primary-300">
                  品牌介绍与内容原则
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-secondary-200 transition-colors hover:text-primary-300">
                  常见问题解答
                </Link>
              </li>
              <li>
                <Link to="/topics" className="text-secondary-200 transition-colors hover:text-primary-300">
                  话题合集总览
                </Link>
              </li>
              <li>
                <a href="#top" className="text-secondary-200 transition-colors hover:text-primary-300">
                  返回顶部
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-secondary-700 pt-6 text-xs text-secondary-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 看料大瓜 · 本站内容为话题梳理与现象观察，仅供参考与讨论。</p>
          <p>持续更新 · 请理性吃瓜</p>
        </div>
      </div>
    </footer>
  );
}